module.exports = __webpack_public_path__ + "static/media/29EUNOG12.a09664e7.jpg";